var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSimple1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 14.6667C5.15967 14.6667 4.99301 14.6 4.85967 14.4734L1.52634 11.14C1.39967 11.0134 1.33301 10.8467 1.33301 10.6667C1.33301 10.4867 1.40634 10.32 1.52634 10.1934L9.28634 2.43337C9.53967 2.18004 9.87301 2.04004 10.2263 2.04004C10.5797 2.04004 10.9197 2.18004 11.1663 2.43337L13.5597 4.82671C14.0797 5.34671 14.0797 6.19337 13.5597 6.71337L5.79967 14.4734C5.66634 14.6067 5.49967 14.6667 5.32634 14.6667H5.33301ZM2.93967 10.6667L5.33301 13.06L12.6197 5.77337L10.2263 3.38671L2.93967 10.6667Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 7.99988C11.1597 7.99988 10.993 7.93322 10.8597 7.80655L8.19305 5.13988C7.93305 4.87988 7.93305 4.45988 8.19305 4.19988C8.45305 3.93988 8.87305 3.93988 9.13305 4.19988L11.7997 6.86655C12.0597 7.12655 12.0597 7.54655 11.7997 7.80655C11.6664 7.93988 11.4997 7.99988 11.3264 7.99988H11.333Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19301 14.6667C1.96634 14.6667 1.74634 14.58 1.58634 14.4133C1.41967 14.2467 1.33301 14.0333 1.33301 13.8V10.6667C1.33301 10.3 1.63301 10 1.99967 10C2.36634 10 2.66634 10.3 2.66634 10.6667V13.3333H5.33301C5.69967 13.3333 5.99967 13.6333 5.99967 14C5.99967 14.3667 5.69967 14.6667 5.33301 14.6667H2.19301Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimple1);
export default __webpack_public_path__ + "static/media/PencilSimple_1.e90021232d8781847cb7c27b602e0ea3.svg";
export { ForwardRef as ReactComponent };